export default __webpack_public_path__ + "static/media/lamb.94da27b4.jpg";